import { render, staticRenderFns } from "./ConfirmedBookings.vue?vue&type=template&id=2ef919d8"
import script from "./ConfirmedBookings.vue?vue&type=script&lang=js"
export * from "./ConfirmedBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports